// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"AbnormalAnalysis_subtitle__3vRnZ","wrapper":"AbnormalAnalysis_wrapper__ny3jO","content":"AbnormalAnalysis_content__1JnOe"};